// extracted by mini-css-extract-plugin
module.exports = {"input":"style_input__zWIJs","generateIdeasButton":"style_generateIdeasButton__sPTJM","numberInput":"style_numberInput__Mii_R"};